import Icon from '../components/Icon.vue'

Icon.register({
  hands: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M204.8 230.4l57.6 76.8c16.6 22.2 25.6 49.1 25.6 76.8v112c0 8.8-7.2 16-16 16h-131.7c-7.2 0-13.5-4.7-15.3-11.6-2-7.8-5.4-15.2-10.4-21.7l-104.1-134.3c-6.8-8.5-10.5-19.1-10.5-30v-218.4c0-17.7 14.3-32 32-32s32 14.3 32 32v148.4l89.8 107.8c6 7.3 16.9 7.8 23.6 1.1l12.8-12.8c5.6-5.6 6.3-14.5 1.5-20.9l-38.1-50.8c-10.6-14.1-7.7-34.2 6.4-44.8s34.2-7.7 44.8 6.4zM608 64c17.7 0 32 14.3 32 32v218.4c0 10.9-3.7 21.5-10.5 30l-104.1 134.3c-5 6.5-8.4 13.9-10.4 21.7-1.8 6.9-8.2 11.6-15.3 11.6h-131.7c-8.8 0-16-7.2-16-16v-112c0-27.7 9-54.6 25.6-76.8l57.6-76.8c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-38.1 50.8c-4.8 6.4-4.1 15.3 1.5 20.9l12.8 12.8c6.6 6.6 17.6 6.1 23.6-1.1l89.8-107.8v-148.4c0-17.7 14.3-32 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hands.js
// module id = 1440
// module chunks = 0